import { render, staticRenderFns } from "./MontageTransformator.vue?vue&type=template&id=12325a2e&scoped=true"
import script from "./MontageTransformator.vue?vue&type=script&setup=true&lang=ts"
export * from "./MontageTransformator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MontageTransformator.vue?vue&type=style&index=0&id=12325a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12325a2e",
  null
  
)

export default component.exports